<template>
  <main class="not-found-page" aria-labelledby="not-found-title">
    <div class="not-found-heading">
      <p class="not-found-code">404</p>
      <h1 id="not-found-title"><span>Page</span> <span>not</span> <span>found</span></h1>
    </div>
    <div class="not-found-details">
      <p>This address doesn’t lead to a page on my site. You can return home to explore my work, research and projects.</p>
      <router-link class="not-found-home" to="/home">
        Return home
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12h17m-6-6 6 6-6 6" /></svg>
      </router-link>
    </div>
  </main>
</template>

<script>
export default { name: 'NotFoundPage' };
</script>

<style>
.container:has(.not-found-page) { width: 90vw; }
.not-found-page { padding-top: clamp(5rem, 16vh, 12rem); padding-bottom: 4rem; }
.not-found-heading { padding-bottom: 2.2rem; border-bottom: 1px solid rgba(80, 80, 80, .16); }
.not-found-code { margin: 0 0 1.2rem; color: var(--site-text-secondary); font: .85rem/1.4 'Quattrocento Sans', sans-serif; letter-spacing: .08em; }
.content-container .not-found-page h1 {
  display: flex;
  justify-content: space-between;
  margin: 0;
  color: #272724;
  font-family: 'PT Serif', Georgia, serif;
  font-size: clamp(3rem, 10.2vw, 12rem);
  font-weight: 400;
  line-height: 1.03;
  letter-spacing: -.065em;
  text-transform: uppercase;
}
.not-found-details { width: 52%; margin-left: auto; padding-top: 2.2rem; font-family: 'Quattrocento Sans', sans-serif; }
.not-found-details p { max-width: 34rem; margin: 0; font-size: clamp(1.15rem, 2.1vw, 1.7rem); line-height: 1.4; }
.not-found-home { display: inline-flex; align-items: center; gap: .55em; margin-top: 3rem; min-height: 44px; font-size: clamp(1.1rem, 1.8vw, 1.5rem); text-decoration: none; }
.not-found-home svg { width: 1.1em; height: 1.1em; fill: none; stroke: currentColor; stroke-width: 1.4; stroke-linecap: round; stroke-linejoin: round; transition: transform 180ms ease; }
.not-found-home:hover svg { transform: translateX(3px); }
.not-found-home:focus-visible { outline: 2px solid currentColor; outline-offset: 6px; }
html.dark-mode .not-found-page h1 { color: #efeee9; }
html.dark-mode .not-found-heading { border-bottom-color: rgba(235, 235, 230, .18); }
@media (max-width: 720px) {
  .not-found-page { padding-top: clamp(6rem, 22vh, 11rem); padding-bottom: 2rem; }
  .content-container .not-found-page h1 { display: block; font-size: clamp(3.5rem, 18vw, 8rem); line-height: .96; letter-spacing: -.055em; }
  .not-found-page h1 span { display: block; }
  .not-found-heading { padding-bottom: 2rem; }
  .not-found-details { width: 100%; padding-top: 1.8rem; }
  .not-found-details p { max-width: 28rem; font-size: 1.25rem; line-height: 1.45; }
  .not-found-home { margin-top: 2.3rem; font-size: 1.2rem; }
}
@media (prefers-reduced-motion: reduce) { .not-found-home svg { transition: none; } }
</style>
